/**
 * customerGroups — Etapa 5 (P1-1: Modo Comercial).
 *
 * Helpers PUROS (sem React/Leaflet) para o agrupamento por cliente.
 * Agrupa devices por customer_id → customer_code → customer_name →
 * "Sem cliente", calcula estatísticas e o status dominante (pior vence).
 * Nenhuma chamada de rede; opera só sobre o DTO já carregado.
 */

export const DOMINANT_COLOR = {
  offline:  "#FF5063",
  relayoff: "#FF8A3C",
  weak:     "#FFB224",
  scorelow: "#FFB224",
  ok:       "#22c55e",
  nodata:   "#6b7280",
};

export const DOMINANT_LABEL = {
  offline:  "Offline",
  relayoff: "Relé OFF",
  weak:     "RSSI fraco",
  scorelow: "Score baixo",
  ok:       "Saudável",
  nodata:   "Sem dados",
};

const NONE_KEY = "__none__";

function computeStats(devices) {
  let online = 0, offline = 0, relayOff = 0, weak = 0;
  let scoreSum = 0, scoreN = 0, scoreLow = 0;
  for (const d of devices) {
    if (!d.online) {
      offline += 1;
    } else {
      online += 1;
      if (d.relay === "off") relayOff += 1;
      else if (d.weak_signal) weak += 1;
    }
    if (d.health_score != null) {
      scoreSum += d.health_score;
      scoreN += 1;
      if (d.health_score < 50) scoreLow += 1;
    }
  }
  const total = devices.length;
  const scoreAvg = scoreN ? Math.round(scoreSum / scoreN) : null;

  let dominant = "nodata";
  if (total > 0) {
    if (offline > 0) dominant = "offline";
    else if (relayOff > 0) dominant = "relayoff";
    else if (weak > 0) dominant = "weak";
    else if (scoreLow > 0) dominant = "scorelow";
    else dominant = "ok";
  }
  const alerts = offline + relayOff + weak + scoreLow;
  return { total, online, offline, relayOff, weak, scoreAvg, scoreLow, dominant, alerts };
}

/** Agrupa devices por cliente. Retorna array de grupos com stats + centro. */
export function groupByCustomer(devices) {
  const map = new Map();
  for (const d of devices || []) {
    const id = d.customer_id || null;
    const code = d.customer_code || null;
    const name = d.customer_name || null;
    const key = id || code || name || NONE_KEY;
    let g = map.get(key);
    if (!g) {
      g = { key, id, code, name, devices: [] };
      map.set(key, g);
    }
    g.devices.push(d);
  }

  const groups = [];
  for (const g of map.values()) {
    const stats = computeStats(g.devices);
    const coords = g.devices.filter((d) => d.lat != null && d.lng != null);
    let lat = null, lng = null;
    if (coords.length) {
      lat = coords.reduce((s, d) => s + d.lat, 0) / coords.length;
      lng = coords.reduce((s, d) => s + d.lng, 0) / coords.length;
    }
    const isNone = g.key === NONE_KEY;
    const label = g.name || g.code || (isNone ? "Sem cliente" : g.key);
    groups.push({ ...g, ...stats, lat, lng, label, isNone });
  }

  // Ordena: mais alertas primeiro, depois por nome.
  groups.sort((a, b) => b.alerts - a.alerts || a.label.localeCompare(b.label));
  return groups;
}
